import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";

export class ProvinciaData {
  id?: number;
  nome?: string;
  regione?: number;

}

export class Provincia {

  data:ProvinciaData = {}

  constructor(data:ProvinciaData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/province`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }

   static async getProvince(regione_id):Promise<Provincia[]> {
     return new Promise((resolve, reject) => {
        ServerService.instance.getAll(Provincia, `/api/province/${regione_id}`).then(res=>{
           resolve(res)
        }).catch(err=>{
           reject(err)
        })
     })
   }

}
